export default {
    path: '/modules/stores',
    name: 'modules-stores',
    component: () => import('@/modules/stores/pages/index.vue'),
    children: [
        {
            path: 'list',
            component: () => import('@/modules/stores/pages/list.vue'),
            meta: {
                pageTitle: '门店列表',
            }
        },
        {
            // path: 'view/:store_id?',
            path:'view',
            component: () => import('@/modules/stores/pages/edit.vue'),
            meta: {
                pageTitle: '查看门店',
                parent: '/modules/stores/list',
            }
        }
    ],

};
